import React from 'react';

/**
 * 트렌딩 아이템 컴포넌트 속성 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const TrendingItemsProperties = [
  {
    group: '트렌딩 아이템 설정',
    properties: [
      {
        name: 'componentProps.title',
        label: '제목',
        control: 'TextField',
        defaultValue: 'Trending now'
      },
      {
        name: 'componentProps.subtitle',
        label: '부제목',
        control: 'TextField',
        defaultValue: '에디터가 선정한'
      },
      {
        name: 'componentProps.imageRadius',
        label: '이미지 둥글기',
        control: 'TextField',
        defaultValue: '4px'
      }
    ]
  },
  {
    group: 'MORE 버튼 설정',
    properties: [
      {
        name: 'componentProps.showMoreButton',
        label: '버튼 표시',
        control: 'Checkbox',
        defaultValue: true
      },
      {
        name: 'componentProps.moreButtonText',
        label: '버튼 텍스트',
        control: 'TextField',
        defaultValue: 'MORE',
        condition: {
          property: 'componentProps.showMoreButton',
          value: true
        }
      },
      {
        name: 'componentProps.moreButtonUrl',
        label: '버튼 URL',
        control: 'TextField',
        defaultValue: '#',
        condition: {
          property: 'componentProps.showMoreButton',
          value: true
        }
      },
      {
        name: 'componentProps.moreButtonBgColor',
        label: '버튼 배경색',
        control: 'ColorPicker',
        defaultValue: 'transparent',
        condition: {
          property: 'componentProps.showMoreButton',
          value: true
        }
      },
      {
        name: 'componentProps.moreButtonTextColor',
        label: '버튼 텍스트 색상',
        control: 'ColorPicker',
        defaultValue: '#8a7a6d',
        condition: {
          property: 'componentProps.showMoreButton',
          value: true
        }
      },
      {
        name: 'componentProps.moreButtonBorderColor',
        label: '버튼 테두리 색상',
        control: 'ColorPicker',
        defaultValue: '#8a7a6d',
        condition: {
          property: 'componentProps.showMoreButton',
          value: true
        }
      },
      {
        name: 'componentProps.moreButtonHoverBgColor',
        label: '호버 배경색',
        control: 'ColorPicker',
        defaultValue: '#8a7a6d',
        condition: {
          property: 'componentProps.showMoreButton',
          value: true
        }
      },
      {
        name: 'componentProps.moreButtonHoverTextColor',
        label: '호버 텍스트 색상',
        control: 'ColorPicker',
        defaultValue: '#ffffff',
        condition: {
          property: 'componentProps.showMoreButton',
          value: true
        }
      }
    ]
  },
  {
    group: '아이템 설정',
    // 아이템은 배열이라 일반적인 방식으로 정의하기 어려움
    // 속성 패널에서 별도 처리 필요
    properties: []
  },
  {
    group: '스타일 설정',
    properties: [
      {
        name: 'style.backgroundColor',
        label: '배경색',
        control: 'ColorPicker',
        defaultValue: 'transparent'
      },
      {
        name: 'style.padding',
        label: '내부 여백',
        control: 'TextField',
        defaultValue: '40px 20px'
      },
      {
        name: 'style.borderRadius',
        label: '테두리 둥글기',
        control: 'TextField',
        defaultValue: '0px'
      }
    ]
  }
];

export default TrendingItemsProperties; 